































import { Component, Prop, Vue } from "vue-property-decorator";
import LangIcon from "vue-material-design-icons/Web.vue";
import { TRANSLATION_LANGUAGES } from "@/shared/languages";

@Component({
  components: {
    LangIcon
  }
})
export default class LanguageDropdown extends Vue {
  @Prop() private disabled!: boolean;

  private selected = "ja";
  private show = false;
  private languages = TRANSLATION_LANGUAGES;

  openDropdown() {
    this.show = !this.show;
  }
  selectDropdown(lang) {
    this.selected = lang;
    this.show = false;
    this.$store.commit("switchLanguage", lang);
  }

  mounted() {
    this.$store.commit("initLanguage");
    this.selected = this.$store.getters.getLanguage;
  }
}
